module.exports = __webpack_public_path__ + "static/media/pet-groomer.30e08ff8.jpg";